import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { deleteProduct } from "#modules/products/infra/deleteProduct.api";
import { productsQuery } from "#modules/products/infra/products.query";

type Options = {
  onSuccess?: () => void;
};

export const useDeleteProduct = (options?: Options) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: (id: string) => deleteProduct(id),
    onSuccess: () => {
      void queryClient.invalidateQueries(productsQuery());
      showSuccessToast({ title: "Produit supprimé" });
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      errorHandler(error);
      showErrorToast({
        title: "Une erreur est survenue",
        message: error.message,
      });
    },
  });

  return { deleteProduct: mutate, ...rest };
};
